<template>
  <!-- Communication Drawer Overlay -->
  <div
    v-if="isOpen"
    class="fixed inset-0 font-inter bg-eerie-black bg-opacity-50 z-50 h-[100dvh]"
    @click="closeDrawer"
  >
    <!-- Communication Drawer Content -->
    <div
      class="fixed top-0 text-lg right-0 w-64 border-l border-total-white-300 h-screen grid grid-rows-[1fr_2fr] bg-eerie-black text-total-white shadow-lg"
      @click.stop
    >
      <!-- Close Button -->
      <button class="absolute top-5 left-5" @click="closeDrawer">
        <i class="fas fa-times text-xl text-total-white"></i>
      </button>

      <!-- Drawer Header: "All Contacts" -->
      <div class="grid items-center">
        <div
          @click="goToAllContacts"
          class="border-y grid grid-cols-[1fr_2fr] items-center p-4 border-total-white-300 text-prime-golden"
        >
          <img
            class="self-center w-4 place-self-center"
            src="../assets/images/contacts-icon.svg"
          />

          <span class="text-lg place-self-start">All Contacts</span>
        </div>
      </div>

      <!-- Communication Options -->
      <div class="mt-6 w-full text-prime-golden">
        <button
          @click="callContact"
          class="w-full grid items-center grid-cols-[1fr_2fr] border-y border-total-white-300 p-4"
        >
          <i class="fas fa-phone text-prime-golden"></i>
          <span class="place-self-center mr-12">Call</span>
        </button>

        <!-- Clicking "Text" navigates to the new text message screen -->
        <button
          @click="textContact"
          class="w-full grid items-center grid-cols-[1fr_2fr] p-4"
        >
          <img class="place-self-center" src="../assets/images/msg-icon.svg" />
          <span class="place-self-center mr-12">Text</span>
        </button>

        <button
          @click="emailContact"
          class="w-full grid items-center grid-cols-[1fr_2fr] border-y border-total-white-300 p-4"
        >
          <i class="fas fa-envelope text-prime-golden"></i>
          <span class="place-self-center mr-12">Email</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    projectId: {
      type: [String, Number],
      required: true,
    },
    currentTab: {
      type: String,
      required: true,
    },
  },
  methods: {
    closeDrawer() {
      this.$emit("close");
    },
    goToAllContacts() {
      this.$router.push({ name: "ContactBookPage" });
    },
    callContact() {
      // Handle the call action
      this.$router.push({
        name: "NewCall",
        params: { projectId: this.projectId, contactId: this.contactId },
        query: { currentTab: this.currentTab },
      });
    },
    textContact() {
      // Navigate to the new text message page
      this.$router.push({
        name: "NewTextMessage",
        params: { projectId: this.projectId },
        query: { currentTab: this.currentTab },
      }); // Assume project ID is 1 for now
    },
    emailContact() {
      this.$router.push({
        name: "NewEmail",
        params: { projectId: this.projectId },
        query: {
          contactId: this.contactId,
          projectId: this.projectId,
          currentTab: this.currentTab,
        },
      }); // Assume project ID is 1 for now
    },
  },
};
</script>

<style scoped></style>
